import { Home, NavigateNext } from '@mui/icons-material';
import { MenuItem, SelectChangeEvent } from '@mui/material';
import React, { useLayoutEffect, useState } from 'react';
import { useBooth } from '../../../../../hooks/useBooth';
import { Booth } from '../../../../../interfaces/interfaces';
import { getBooth } from '../../../../../services/services';
import VySelect from '../../../../common/VySelect';

interface Breadcrumb extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  booth: Booth;
}

const Breadcrumb = ({ booth, className, ...props }: Breadcrumb) => {
  const [peers, setPeers] = useState<Booth[]>([]);

  const { openBooth } = useBooth();

  useLayoutEffect(() => {
    (async function fetchPeers() {
      if (!booth?.parentBooth || typeof booth?.parentBooth === 'string') return;
      const parentBooth = await getBooth({ boothid: booth.parentBooth._id });
      parentBooth.childBooths && setPeers(parentBooth.childBooths);
    })();
  }, [booth]);

  function HandleParentClick() {
    if (!booth?.parentBooth || typeof booth?.parentBooth === 'string') return null;
    openBooth(booth?.parentBooth?._id);
  }

  function handlePeerChange(event: SelectChangeEvent<unknown>) {
    openBooth(event.target.value as string);
  }

  if (!booth?.parentBooth || typeof booth?.parentBooth === 'string') return null; // resi

  return (
    <div {...props} className={`flex items-center ${className}`} style={{ color: booth?.event?.template?.mainColor || 'var(--vystem-blue)' }}>
      <Home className="mr-2" style={{ fontSize: '22px' }} />
      <p onClick={HandleParentClick} className="text-xs cursor-pointer" style={{ paddingTop: '2px', fontSize: '13px' }}>
        {booth.parentBooth.name}
      </p>
      <NavigateNext className="mx-2" style={{ fontSize: '22px' }} />
      <VySelect className="text-xs" style={{ paddingTop: '2px', fontSize: '13px', color: 'inherit' }} onChange={handlePeerChange} defaultValue={booth._id}>
        {peers.map((p) => (
          <MenuItem style={{ color: 'inherit' }} key={p._id} value={p._id}>
            {p.name}
          </MenuItem>
        ))}
      </VySelect>
    </div>
  );
};

export default Breadcrumb;
